(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rwady-section-results"]) return;
  try {
    
  (() => {
    if (customElements.get('rwady-section-results')) return;
    const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    const handlePattern = /^[\p{L}\p{Nd}][\p{L}\p{Nd}_-]{0,254}$/u;
    const pageSize = 24;
    class RwadySectionResults extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.grid = this.querySelector('[data-results-grid]');
        this.status = this.querySelector('[data-results-status]');
        this.retry = this.querySelector('[data-results-retry]');
        this.previous = this.querySelector('[data-results-previous]');
        this.next = this.querySelector('[data-results-next]');
        this.pagination = this.querySelector('[data-results-pagination]');
        this.title = this.querySelector('[data-results-title]');
        this.locale = this.dataset.locale === 'ar' ? 'ar' : 'en';
        const root = (this.dataset.root || '/').replace(/\/?$/, '/');
        this.root = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(root) ? root : '/';
        this.sectionId = new URL(location.href).searchParams.get('rwady_section') || '';
        this.page = this.readPage();
        this.retry.addEventListener('click', () => this.load(this.requestedPage || this.page, this.requestedHistory));
        this.previous.addEventListener('click', () => this.load(Math.max(1, this.page - 1), true));
        this.next.addEventListener('click', () => this.load(this.page + 1, true));
        this.onPopState = () => this.load(this.readPage());
        window.addEventListener('popstate', this.onPopState);
        this.load(this.page);
      }
      disconnectedCallback() {
        this.controller?.abort();
        window.removeEventListener('popstate', this.onPopState);
        this.started = false;
      }
      readPage() {
        const value = new URL(location.href).searchParams.get('page') || '1';
        const page = Number(value);
        return /^\d+$/.test(value) && Number.isSafeInteger(page) && page > 0 && page <= 100000 ? page : 1;
      }
      endpoint(page) {
        const url = new URL('https://rwady-content-buddy.lovable.app/api/public/section-products/v1');
        url.search = new URLSearchParams({ section_id: this.sectionId, locale: this.locale, page: String(page), page_size: String(pageSize) }).toString();
        return url.href;
      }
      validate(body, page) {
        if (!body || body.complete !== true || body.section?.id !== this.sectionId || !Array.isArray(body.products) ||
          !Number.isSafeInteger(body.total) || body.total < 0 || body.page !== page || body.page_size !== pageSize ||
          body.products.length !== Math.min(pageSize, Math.max(0, body.total - (page - 1) * pageSize)) ||
          body.has_more !== (page * pageSize < body.total)) throw new Error('Invalid results');
        const handles = new Set();
        for (const product of body.products) {
          if (!product || !handlePattern.test(product.handle || '') || handles.has(product.handle) ||
            typeof product.title !== 'string' || !Number.isFinite(product.price) || product.price < 0) throw new Error('Invalid product');
          handles.add(product.handle);
        }
        return body;
      }
      async load(page, updateHistory = false) {
        this.controller?.abort();
        const controller = new AbortController();
        this.controller = controller;
        this.requestedPage = page;
        this.requestedHistory = updateHistory;
        this.retry.hidden = true;
        this.previous.disabled = this.next.disabled = true;
        if (!uuid.test(this.sectionId)) {
          this.status.textContent = this.dataset.unavailable;
          this.grid.replaceChildren();
          this.grid.setAttribute('aria-busy', 'false');
          return;
        }
        this.status.textContent = this.dataset.loading;
        this.grid.setAttribute('aria-busy', 'true');
        const timeout = setTimeout(() => controller.abort(), 120000);
        try {
          let response;
          let requestError;
          for (let attempt = 0; attempt < 3; attempt += 1) {
            try {
              response = await fetch(this.endpoint(page), { headers: { Accept: 'application/json' }, credentials: 'omit', signal: controller.signal });
              if (response.ok || response.status === 404) break;
              requestError = new Error('Request failed');
            } catch (error) {
              if (controller.signal.aborted) throw error;
              requestError = error;
            }
            if (attempt < 2) await new Promise((resolve) => setTimeout(resolve, 1500 * (attempt + 1)));
          }
          if (!response) throw requestError || new Error('Request failed');
          if (this.controller !== controller) return;
          if (response.status === 404) {
            this.grid.replaceChildren();
            this.pagination.hidden = true;
            this.querySelector('[data-results-count]').hidden = true;
            this.status.textContent = this.dataset.unavailable;
            return;
          }
          if (!response.ok) throw requestError || new Error('Request failed');
          const body = this.validate(await response.json(), page);
          if (this.controller !== controller) return;
          this.page = page;
          this.title.textContent = body.section.title || this.title.textContent;
          const subtitle = this.querySelector('[data-results-subtitle]');
          subtitle.textContent = body.section.subtitle || '';
          subtitle.hidden = !subtitle.textContent;
          const count = this.querySelector('[data-results-count]');
          count.textContent = String(body.total) + ' ' + this.dataset.countLabel;
          count.hidden = false;
          this.grid.replaceChildren(...body.products.map((product) => this.card(product)));
          this.status.textContent = body.products.length ? '' : this.dataset.empty;
          this.pagination.hidden = body.total <= pageSize;
          this.querySelector('[data-results-page]').textContent = this.dataset.pageLabel + ' ' + page + ' / ' + Math.max(1, Math.ceil(body.total / pageSize));
          this.previous.disabled = page <= 1;
          this.next.disabled = !body.has_more;
          if (updateHistory) {
            const url = new URL(location.href);
            url.searchParams.set('page', String(page));
            history.pushState(null, '', url);
            this.title.focus({ preventScroll: true });
            this.scrollIntoView({ block: 'start', behavior: 'auto' });
          }
        } catch (_) {
          if (this.controller !== controller || !this.isConnected) return;
          this.status.textContent = this.dataset.error;
          this.retry.hidden = false;
        } finally {
          clearTimeout(timeout);
          if (this.controller === controller) this.grid.setAttribute('aria-busy', 'false');
        }
      }
      card(product) {
        const card = document.createElement('li');
        card.className = 'rwady-section-results__card';
        const link = document.createElement('a');
        link.href = this.root + 'products/' + encodeURIComponent(product.handle);
        const media = document.createElement('div');
        media.className = 'rwady-section-results__media';
        const placeholder = () => {
          const label = document.createElement('span');
          label.textContent = this.dataset.noImage;
          media.replaceChildren(label);
        };
        let imageUrl = null;
        try { const url = new URL(product.image); if (url.protocol === 'https:') imageUrl = url.href; } catch (_) {}
        if (imageUrl) {
          const image = document.createElement('img');
          image.src = imageUrl;
          image.alt = product.title;
          image.width = image.height = 360;
          image.loading = 'lazy';
          image.decoding = 'async';
          image.addEventListener('error', placeholder, { once: true });
          media.append(image);
        } else placeholder();
        const title = document.createElement('h2');
        title.textContent = product.title;
        const stock = document.createElement('span');
        stock.className = 'rwady-section-results__stock';
        stock.dataset.available = String(product.available === true);
        stock.textContent = product.available === true ? this.dataset.available : this.dataset.soldOut;
        const price = document.createElement('div');
        price.className = 'rwady-section-results__price';
        const discounted = Number.isFinite(product.compareAtPrice) && product.compareAtPrice > product.price;
        price.dataset.discounted = String(discounted);
        const current = document.createElement('strong');
        const money = (amount) => {
          const number = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(amount);
          return this.locale === 'ar' ? this.dataset.currency + ' ' + number : number + ' ' + this.dataset.currency;
        };
        current.textContent = money(product.price);
        current.dir = 'ltr';
        price.append(current);
        if (discounted) {
          const compare = document.createElement('s');
          compare.textContent = money(product.compareAtPrice);
          compare.dir = 'ltr';
          price.append(compare);
        }
        link.append(media, title, stock, price);
        card.append(link);
        return card;
      }
    }
    customElements.define('rwady-section-results', RwadySectionResults);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rwady-thank-you"]) return;
  try {
    
const retryCompletedCartCleanup = () => {
  const page = document.querySelector('[data-rwady-thanks]');
  if (!page || !window.RwadyOrderConfirmation) return;
  try {
    window.RwadyOrderConfirmation.create({ baseUrl: '', storage: localStorage }).cleanupCart(page.dataset.rootUrl || '/').catch(() => {});
  } catch (_) {}
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', retryCompletedCartCleanup, { once: true });
else retryCompletedCartCleanup();
(() => {
  const page = document.querySelector('[data-rwady-thanks]');
  if (!page || page.dataset.ready) return;
  try {
    const record = JSON.parse(localStorage.getItem('rwady-native-checkout-v1') || 'null');
    const result = record?.result;
    if (record?.phase !== 'submitted' || result?.ok !== true || result.status !== 'submitted' || result.request_id !== record.request_id || !/^gid:\/\/shopify\/Order\/\d+$/.test(result.order?.id || '') || typeof result.order.name !== 'string' || !result.order.name || result.order.currency !== 'IQD' || !Number.isFinite(result.order.total) || result.order.total < 0) return;
    const labels = JSON.parse(page.querySelector('[data-thanks-labels]').textContent);
    const rtl = page.dir === 'rtl';
    const money = value => new Intl.NumberFormat('en-US').format(value) + (rtl ? ' د.ع' : ' IQD');
    const safeImage = value => {
      try { const url = new URL(value, location.origin); return url.protocol === 'https:' && (url.hostname === location.hostname || ['cdn.shopify.com', 'rwady.com', 'rwady.com.iq'].includes(url.hostname)) ? url.href : ''; } catch (_) { return ''; }
    };
    const warranty = value => {
      const text = String(value ?? '').trim();
      if (!text) return '';
      if (/^\d+(\.\d+)?$/.test(text)) return Number(text) === 1 ? labels.year_one : Number(text) === 2 ? labels.year_two : text + ' ' + labels.years;
      return text;
    };
    let summary = null;
    try { summary = JSON.parse(sessionStorage.getItem('rwady-thank-you-summary') || 'null'); } catch (_) {}
    if (summary?.request_id !== result.request_id) summary = null;
    const items = Array.isArray(summary?.items) ? summary.items : [];
    const shipping = Number.isFinite(summary?.shipping) && summary.shipping >= 0 ? summary.shipping : null;
    const trackedProductsTotal = Number(summary?.products_total);
    const trackPurchase = () => {
      const pixelId = String(page.dataset.metaPixelId || '').trim();
      const orderId = String(result.order.id).split('/').pop();
      const eventId = 'shopify_order_' + orderId;
      const storageKey = 'rwady-meta-purchase-' + orderId;
      if (!/^\d{8,20}$/.test(pixelId) || localStorage.getItem(storageKey) === eventId) return;
      const purchaseItems = items.filter(item => Number.isFinite(item.quantity) && item.quantity > 0);
      const contents = purchaseItems.map(item => ({ id: String(item.variant_id || '').trim(), quantity: item.quantity, item_price: Number(item.unit_price) || 0 })).filter(item => item.id);
      if (!contents.length || contents.length !== purchaseItems.length) return;
      const fallbackTotal = contents.reduce((sum, item) => sum + item.quantity * item.item_price, 0);
      const value = Number.isFinite(trackedProductsTotal) && trackedProductsTotal >= 0 ? trackedProductsTotal : fallbackTotal;
      if (!window.fbq) {
        const fbq = function(){ fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments); };
        fbq.push = fbq; fbq.loaded = true; fbq.version = '2.0'; fbq.queue = [];
        window.fbq = fbq;
        const script = document.createElement('script');
        script.async = true; script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.append(script);
      }
      const customData = { value, currency: 'IQD', content_type: 'product', content_ids: contents.map(item => item.id), contents };
      const serverEvent = { event_name: 'Purchase', event_id: eventId, custom_data: customData };
      window.fbq('init', pixelId);
      window.fbq('track', 'Purchase', customData, { eventID: eventId });
      if (window.RwadyMetaCheckout && typeof window.RwadyMetaCheckout.sendServerEvent === 'function') {
        void window.RwadyMetaCheckout.sendServerEvent(serverEvent);
      } else {
        window.RwadyMetaServerQueue = window.RwadyMetaServerQueue || [];
        window.RwadyMetaServerQueue.push(serverEvent);
      }
      localStorage.setItem(storageKey, eventId);
    };
    trackPurchase();
    const payment = labels[record.payment_method] || labels.payment_note;
    page.querySelector('[data-thanks-number]').textContent = result.order.name;
    page.querySelector('[data-thanks-payment]').textContent = payment;
    const depositNote = page.querySelector('[data-thanks-deposit-note]');
    if (depositNote) depositNote.hidden = record.payment_method !== 'cash_on_delivery';
    const followUpLabel = record.payment_method === 'cash_on_delivery' ? 'cod_note' : record.payment_method === 'installment' ? 'installment_note' : record.payment_method === 'online' ? 'online_payment_note' : record.payment_method === 'electronic_transfer' ? 'transfer_note' : 'payment_note';
    page.querySelector('[data-thanks-follow-up]').textContent = labels[followUpLabel];
    const download = page.querySelector('[data-thanks-download]');
    const complete = items.length > 0 && shipping !== null && items.every(item => Number.isFinite(item.quantity) && item.quantity > 0 && Number.isFinite(item.unit_price) && item.unit_price >= 0);
    download.disabled = !complete;
    if (!complete) { const message = page.querySelector('[data-thanks-download-error]'); message.textContent = labels.download_missing; message.hidden = false; }
    const pdf = pages => {
      const encoder = new TextEncoder();
      const parts = [], offsets = [0]; let length = 0;
      const push = value => { const bytes = typeof value === 'string' ? encoder.encode(value) : value; parts.push(bytes); length += bytes.length; };
      const object = (id, body) => { offsets[id] = length; push(id + ' 0 obj\n'); push(body); push('\nendobj\n'); };
      push('%PDF-1.4\n');
      object(1, '<< /Type /Catalog /Pages 2 0 R >>');
      object(2, '<< /Type /Pages /Count ' + pages.length + ' /Kids [' + pages.map((_, i) => (3 + i * 3) + ' 0 R').join(' ') + '] >>');
      pages.forEach((data, i) => {
        const id = 3 + i * 3, bytes = Uint8Array.from(atob(data.split(',')[1]), char => char.charCodeAt(0));
        object(id, '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 595.28 841.89] /Resources << /XObject << /Image ' + (id + 1) + ' 0 R >> >> /Contents ' + (id + 2) + ' 0 R >>');
        offsets[id + 1] = length; push((id + 1) + ' 0 obj\n<< /Type /XObject /Subtype /Image /Width 1240 /Height 1754 /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + bytes.length + ' >>\nstream\n'); push(bytes); push('\nendstream\nendobj\n');
        const stream = 'q\n595.28 0 0 841.89 0 0 cm\n/Image Do\nQ\n';
        object(id + 2, '<< /Length ' + encoder.encode(stream).length + ' >>\nstream\n' + stream + 'endstream');
      });
      const start = length;
      push('xref\n0 ' + offsets.length + '\n0000000000 65535 f \n');
      offsets.slice(1).forEach(offset => push(String(offset).padStart(10, '0') + ' 00000 n \n'));
      push('trailer\n<< /Size ' + offsets.length + ' /Root 1 0 R >>\nstartxref\n' + start + '\n%%EOF');
      return new Blob(parts, { type: 'application/pdf' });
    };
    const makeReceipt = async () => {
      await document.fonts?.ready;
      const pages = [];
      const canvas = document.createElement('canvas'); canvas.width = 1240; canvas.height = 1754;
      const ctx = canvas.getContext('2d');
      const family = getComputedStyle(page).fontFamily || 'Arial';
      const blue = '#163f82', pale = '#edf3fd';
      let y = 0, pageNumber = 0;
      const text = (value, x, top, size = 20, weight = 400, color = '#172033', align = 'right', direction = rtl ? 'rtl' : 'ltr') => {
        ctx.font = weight + ' ' + size + 'px ' + family; ctx.fillStyle = color; ctx.textAlign = align; ctx.textBaseline = 'top'; ctx.direction = direction; ctx.fillText(String(value), x, top);
      };
      const lines = (value, width, size = 20, weight = 400) => {
        ctx.font = weight + ' ' + size + 'px ' + family;
        const result = []; let line = '';
        for (const word of String(value || '').split(/\s+/)) {
          if (ctx.measureText((line ? line + ' ' : '') + word).width <= width) line += (line ? ' ' : '') + word;
          else {
            if (line) result.push(line); line = '';
            for (const char of word) { if (ctx.measureText(line + char).width > width && line) { result.push(line); line = ''; } line += char; }
          }
        }
        if (line) result.push(line); return result;
      };
      const rect = (x, top, w, h, color) => { ctx.fillStyle = color; ctx.fillRect(x, top, w, h); };
      const imageCache = new Map();
      const loadImage = async src => {
        const url = safeImage(src); if (!url) return null;
        if (!imageCache.has(url)) imageCache.set(url, new Promise(resolve => {
          const img = new Image(); img.crossOrigin = 'anonymous';
          const timer = setTimeout(() => resolve(null), 5000);
          img.onload = () => { clearTimeout(timer); resolve(img); }; img.onerror = () => { clearTimeout(timer); resolve(null); }; img.src = url;
        }));
        return imageCache.get(url);
      };
      const drawImage = (img, x, top, width, height) => {
        if (!img) return;
        const scale = Math.min(width / img.naturalWidth, height / img.naturalHeight);
        ctx.drawImage(img, x + (width - img.naturalWidth * scale) / 2, top + (height - img.naturalHeight * scale) / 2, img.naturalWidth * scale, img.naturalHeight * scale);
      };
      const logo = await loadImage(page.querySelector('[data-thanks-logo]')?.src);
      const stamp = await loadImage(page.dataset.receiptStamp);
      const receiptMoney = value => new Intl.NumberFormat('en-US').format(value) + ' IQD';
      const finish = () => { text(labels.receipt_footer, 620, 1675, 24, 700, blue, 'center'); text(pageNumber, 1165, 1690, 15, 400, '#65748b', 'right', 'ltr'); pages.push(canvas.toDataURL('image/jpeg', .94)); };
      const start = () => {
        if (pageNumber) finish(); pageNumber++;
        rect(0, 0, 1240, 1754, '#fff');
        if (logo) drawImage(logo, 550, 58, 140, 140);
        text(labels.company, 620, 230, 38, 700, blue, 'center');
        text(labels.receipt_location, 620, 286, 19, 400, '#596779', 'center');
        y = 331; rect(50, y, 1140, 2, '#0941ad'); y += 44;
        const invoiceId = 'INV-' + result.order.name.replace(/[^A-Za-z0-9_-]/g, '');
        text(labels.receipt_number + ': ' + invoiceId, 50, y, 24, 700, '#1e5ebf', 'left');
        text(labels.bill_to, 1185, y, 21, 700, '#1e5ebf');
        const date = summary?.created_at ? new Date(summary.created_at) : null;
        if (date && Number.isFinite(date.getTime())) text(labels.receipt_date + ': ' + date.toLocaleDateString('en-GB'), 50, y + 43, 20, 400, '#596779', 'left');
        y += 42;
        if (pageNumber === 1 && summary?.customer) {
          const details = [summary.customer.name, summary.customer.phone, summary.customer.address];
          details.forEach((value, index) => {
            if (!value) return;
            for (const line of lines(value, 570, index === 0 ? 24 : 20, index === 0 ? 700 : 400)) {
              text(line, 1185, y, index === 0 ? 24 : 20, index === 0 ? 700 : 400, index === 2 ? '#1e5ebf' : '#172033'); y += 32;
            }
          });
        }
        y = Math.max(y + 22, 525);
      };
      const ensure = height => { if (y + height > 1610) start(); };
      const header = () => {
        rect(50, y, 1140, 48, blue);
        [[1164,'#'],[1080,rtl?'الصورة':'Image'],[818,labels.receipt_product],[510,labels.warranty],[350,labels.unit_price],[238,labels.quantity],[126,labels.line_total]].forEach(([x,label])=>text(label,x,y+12,18,700,'#fff','center'));
        y += 48;
      };
      start(); header();
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const titleLines = lines(item.title, 360, 19, 700);
        const warrantyLines = lines(warranty(item.warranty), 120, 17);
        const height = Math.max(124, titleLines.length * 28 + 50, warrantyLines.length * 26 + 30);
        if (y + height > 1570) { start(); header(); }
        rect(50,y,1140,height,i % 2 ? '#f8faff' : '#fff'); rect(50,y,151,height,pale); rect(1140,y,50,height,blue);
        text(i+1,1164,y+25,19,700,'#fff','center','ltr');
        drawImage(await loadImage(item.image),1022,y+12,104,height-24);
        titleLines.forEach((line,j)=>text(line,1000,y+16+j*28,19,700,blue,'right',/[\u0600-\u06ff]/.test(line)?'rtl':'ltr'));
        if (item.sku) lines('SKU: '+item.sku,360,15).forEach((line,j)=>text(line,1000,y+20+titleLines.length*28+j*22,15,400,'#596779','right','ltr'));
        warrantyLines.forEach((line,j)=>text(line,510,y+22+j*26,17,400,'#172033','center'));
        text(new Intl.NumberFormat('en-US').format(item.unit_price),350,y+28,19,400,'#172033','center','ltr');
        text(item.quantity,238,y+28,19,400,'#172033','center','ltr');
        text(new Intl.NumberFormat('en-US').format(item.unit_price*item.quantity),126,y+28,19,700,blue,'center','ltr');
        y += height; rect(50,y,1140,1,'#dce4f0');
      }
      y += 24; ensure(240);
      const subtotal = items.reduce((sum,item)=>sum+item.quantity*item.unit_price,0);
      const amountRow = (label,value,strong=false) => {
        rect(50,y,1140,strong?70:48,strong?pale:'#fff');
        if (strong) rect(50,y,1140,3,'#1e5ebf');
        text(label,strong?970:1170,y+14,strong?29:20,strong?700:400,strong?blue:'#172033',strong?'center':'right');
        text(typeof value === 'string' ? value : receiptMoney(value),strong?335:66,y+14,strong?25:20,strong?700:400,strong?blue:'#172033',strong?'center':'left',typeof value === 'string' ? (rtl?'rtl':'ltr') : 'ltr');
        y+=strong?86:50;
      };
      amountRow(labels.receipt_subtotal,subtotal);
      amountRow(labels.receipt_shipping,shipping === 0 ? labels.free_shipping : shipping);
      const adjustment = Math.round((result.order.total - subtotal - shipping)*100)/100;
      if (adjustment) amountRow(labels.adjustment,adjustment);
      amountRow(labels.receipt_total,result.order.total,true);
      y += 12;
      const notes = [1,2,3,4].map(index => labels['receipt_warranty_' + index]);
      const noteLines = notes.flatMap(value => lines(value,1050,19).map((text,index) => ({text,first:index === 0})));
      ensure(60 + noteLines.length * 32);
      rect(50,y,1140,56,pale); rect(1184,y,6,56,'#1e5ebf'); text(labels.warranty_notes,1170,y+16,23,700,blue); y+=56;
      for (const line of noteLines) {
        ensure(34); rect(50,y,1140,34,pale); rect(1184,y,6,34,'#1e5ebf');
        if (line.first) { ctx.fillStyle = '#1684c8'; ctx.beginPath(); ctx.moveTo(1168,y+7); ctx.lineTo(1176,y+15); ctx.lineTo(1168,y+23); ctx.lineTo(1160,y+15); ctx.closePath(); ctx.fill(); }
        text(line.text,1148,y+3,19); y+=34;
      }
      if (stamp) { ensure(270); drawImage(stamp,115,Math.max(y+75,1360),220,220); }
      finish(); return pdf(pages);
    };
    download.addEventListener('click', () => {
      const message = page.querySelector('[data-thanks-download-error]');
      message.textContent = rtl
        ? 'سوف تجد وصل الشراء والضمان في قسم وصولات الشراء في صفحة حسابك بعد تأكيد الطلب.'
        : 'You will find the purchase receipt and warranty in the Purchase receipts section of your account after the order is confirmed.';
      message.hidden = false;
    });
    page.dataset.ready = 'true';
    page.querySelector('[data-thanks-success]').hidden = false;
    page.querySelector('[data-thanks-empty]').hidden = true;
  } catch (_) {}
})();


  } catch(e) { console.error(e); }
})();
})();
